import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { person, links } from "../data/site";

const words = person.name.split(" ");

export default function Hero() {
  const ref = useRef(null);
  const reduced = useReducedMotion();

  // The hero recedes as the page takes over, rather than scrolling away flat.
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <section className="hero" ref={ref} id="top">
      <motion.div
        className="hero__inner shell"
        style={reduced ? undefined : { y, opacity }}
      >
        <p className="label hero__meta">
          {person.role}
          <span className="hero__sep" aria-hidden="true" />
          {person.location}
        </p>

        <h1 className="display hero__name">
          {words.map((word, i) => (
            <motion.span
              key={word}
              className="hero__word"
              initial={{ opacity: 0, y: "0.35em" }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 1,
                delay: 0.1 + i * 0.09,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              {word}
            </motion.span>
          ))}
        </h1>

        <motion.div
          className="hero__body"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="lead">{person.statement}</p>

          <div className="hero__actions">
            <a className="cta cta--solid" href="#work">
              See the work
            </a>
            <a className="cta" href={person.cv} target="_blank" rel="noreferrer">
              Download CV
            </a>
          </div>

          <ul className="hero__links">
            {[
              ["GitHub", links.github],
              ["LinkedIn", links.linkedin],
              ["Instagram", links.instagram],
            ].map(([label, href]) => (
              <li key={label}>
                <a className="link label" href={href} target="_blank" rel="noreferrer">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </motion.div>
      </motion.div>
    </section>
  );
}
